<div class="rounded-3" style="overflow: auto;">
    <table mat-table class="w-100 h-100" [dataSource]="dataSource" multiTemplateDataRows>
        <ng-content></ng-content>
    </table>
</div>

<mat-paginator class="w-100 mt-2" [class]="items && items.length <= 0 ? 'd-none' : null"
    [pageSizeOptions]="pageSizeOptions" [length]="items.length" [hidePageSize]="hidePageSize" pageSize="pageSize"
    [ngStyle]="{minWidth: 'fit-content'}" (page)="pageChange($event)">
</mat-paginator>
